<template>
<div>
  <a-table
    ref="table"
    size="middle"
    :scroll="{x:true}"
    rowKey="id"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="ipagination"
    :loading="loading"
    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
    :customHeaderRow="customHeaderRow"
    :customRow="customRow"
    class="j-table-force-nowrap"
    @change="handleTableChange">
      <template :slot="column.scopedSlots?column.scopedSlots.customRender:''" slot-scope="text,record"  v-for="column in columns">
        <slot :name="column.scopedSlots?column.scopedSlots.customRender:''" v-bind="record" >
          <div v-if="column.dataIndex=='remark'" :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text">
            <img v-if="record.headImg" :src="getImgView(record.headImg)" height="25px" alt="" style="width:25px;font-size: 12px;font-style: italic;border-radius:50%"/>
            <span>{{text || '-'}}</span>
          </div>
          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-else-if="column.dataIndex=='instanceId'">
            <a @click.stop="bfAudio(record)" v-if="record.instanceId && record.status==2">录音</a>
          </div>
          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-else-if="column.dataIndex=='callStartTime'">{{(record.callEndTime&&record.callStartTime)?evalCallTimeTwo(text,record.callEndTime):''}}</div>
          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-else>{{text || '-'}}</div>

        </slot>
      </template>



  </a-table>

  <a-modal :visible="audioVisible" @cancel="audioCancel()" :okButtonProps="{ class:{'jee-hidden': true} }" cancelText="关闭">
    <audio
      :src="audioUrl"
      autoplay="autoplay"
      controls="controls"
      ref="audio"
    >录音文件播放</audio>
  </a-modal>
</div>


</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction } from '@/api/manage'
  import {evalCallTimeTwo} from '@/utils/util'
  export default {
    name: 'CallRecordTable',
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      },
      phone:{
        type:String,
        default:''
      }
    },data(){
      return {
        columns: [
          {
            title:'呼叫时间',
            align:"center",
            fixed:'left',
            width:180,
            dataIndex: 'createTime',
            scopedSlots: { customRender: 'createTimeSlot' }
          },{
            title: '呼叫状态',
            dataIndex: 'status_dictText',
            align:"center",
            width:140,
            scopedSlots: { customRender: 'status_dictTextSlot' }
          },
          {
            title:'通话时间',
            align:"center",
            width:180,
            dataIndex: 'callStartTime',
            scopedSlots: { customRender: 'callStartTimeSlot' }
          },
          {
            title: '主叫号码',
            dataIndex: 'caller',
            align:"center",
            width:180,
            scopedSlots: { customRender: 'callerSlot' }
          },
          {
            title:'录音',
            align:"center",
            width:140,
            dataIndex: 'instanceId',
            scopedSlots: { customRender: 'instanceIdSlot' },
          },
          {
            title: '备注',
            align:"center",
            width:200,
            fixed:'right',
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remarkSlot' },
          }
        ],
        url: {
          list: "/dm/dmDriverCallRecord/list"
        },disableMixinCreated:true,
        evalCallTimeTwo:evalCallTimeTwo,
        audioVisible:false,
        audioUrl:''
      }
    },methods:{
      customHeaderRow(conlumn){
        console.log(conlumn)
        conlumn.forEach((e,index)=>{
          conlumn[index].className = 'header-class'
        })
      },customRow(record){
        let that = this;
        let cls = "row-class";
        return {
          class:cls,
          on:{
          click:()=>{
            that.viewInfo(record);
          }
        }
        }
      },loadList(){
        this.queryParam.driverId = this.driverId;
        this.queryParam.callee = this.phone;
        this.loadData();
      },viewInfo(record){
        this.$emit("to",record.phone);
      },bfAudio(record){
        let that = this;
        getAction("/dm/dmDriverCallRecord/queryVideoById",{id:record.id}).then((res)=>{
          if(res.success){
            if(res.result.videoUrl){
              that.audioVisible = true;
              that.audioUrl = res.result.videoUrl
            }else{
              this.$message.warning("播放错误");
            }
          }
        });

      },audioCancel(){
        this.audioVisible = false;
        this.$refs.audio.pause();
        this.$refs.audio.currentTime = 0;
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/dm/newTable.less';
  /deep/ .hui-class td{
    color: #91929e !important;
  }
</style>